import React from "react";
import { EmptyState } from "../../../../common/components/emptyState/EmptyState";
import styles from "./CategoryTileList.module.scss";
import { MdCategory } from "react-icons/md";
import CategoryItem from "../categoryItem/CategoryItem";
import { useCategoryScreen } from "./useCategoryTileList";

const CategoryTileList = () => {
  const { list } = useCategoryScreen();

  return (
    <div className={styles.container}>
      {list.length === 0 ? (
        <div className={styles.emptyWrapper}>
          <EmptyState
            icon={MdCategory}
            title="Нет категорий"
            description="Категории появятся после добавления"
          />
        </div>
      ) : (
        <div className={styles.grid}>
          {list.map((el) => (
            <div key={el.id} className={styles.gridItem}>
              <CategoryItem category={el} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryTileList;
